import HttpClient from './httpClient'

export default function CommonServives() {
    const { httpClient } = HttpClient()

    function create(schemas, params) {
        return httpClient
            .post(schemas, params)
            .then((response) => {
                return response.data || response.response.data
            })
            .catch((err) => {
                return err.data
            })
    }


    function update(schemas, id, params) {
        return httpClient
            .put(id ? `${schemas}/${id}` : `${schemas}`, params)
            .then((response) => {
                return response.data || response.response.data
            })
            .catch((error) => {
                return error.data
            })
    }

    function getById(schemas, id, params = {}) {
        return httpClient
            .get(`${schemas}/${id}`, { params })
            .then((response) => {
                return response.data || response.response.data
            })
            .catch((error) => {
                return error.data
            })
    }

    function getList(schemas, params) {
        return httpClient
            .get(schemas, { params })
            .then((response) => {
                return response.data || response.response.data
            })
            .catch((err) => {
                return err.data
            })
    }

    // function getUser(schemas) {
    //     return httpClient
    //         .get(schemas)
    //         .then((response) => {
    //             return response.data || response.response.data
    //         })
    //         .catch((err) => {
    //             return err.data
    //         })
    // }

    return { create, update, getById, getList, /*getUser*/ }
}
